import { CourseContentsScreen } from '@screens/CourseContentsScreen'

export default function CourseContents() {
  return <CourseContentsScreen />
}
